/* eslint-disable no-irregular-whitespace */

import { Col, Divider, Row, Timeline, Tooltip, Empty, Spin } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Paragraph from 'antd/lib/typography/Paragraph';
import LeadgenStudentInfo from './booking-student-info';
import ProductInfo from './product-info';
import CommissionInfo from 'common/components/commission-info';
import BookingStatus from 'common/components/booking-status';
import { useQuery } from '@apollo/client';
import { QUERY_LISTORDER_DETAIL } from '../queries';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { bookingJourneyType } from 'common/constants/booking';

function BookingDetail() {
  const { id: referenceId, bookingJourney } = useParams();
  const isLeadGen = bookingJourney === bookingJourneyType.LEAD_GENERATION;

  // const [bookingData, setBookingData] = React.useState(null);

  const { data: tempBookData, loading: bookingDetailLoading } = useQuery(QUERY_LISTORDER_DETAIL, {
    variables: { referenceId, bookingJourneys: [bookingJourney] },
    onCompleted: () => {
      // let temp = data?.viewer?.company?.orders?.edges;
      // setBookingData({ ...temp[0]?.node });
    },
    fetchPolicy: 'network-only',
    onError: error => {
      console.log('[ error ] >', error);
    },
  });
  const bookingData = tempBookData?.listOrders?.edges
    ? tempBookData?.listOrders?.edges[0]?.node
    : null;

  const { t } = useTranslation('landlord');

  const renderTooltipContainer = text => (
    <div className="longtail-booking-details__tooltip-container">
      <span className="longtail-booking-details__tooltip-container__text">{text}</span>
    </div>
  );
  const headerNavList = {
    'student-info': 'student',
    'product-info': 'product',
  };

  if (isLeadGen) {
    headerNavList['commission-info'] = 'commission-info';
    headerNavList['note-info'] = 'note';
  }

  const [currentTab, setCurrentTab] = React.useState(0);

  const handleNavClick = (target, idx) => {
    const targetElement = document.querySelector(`#${target}`);

    setCurrentTab(idx);
    if (targetElement) {
      window.scrollTo(0, targetElement.offsetTop - 73);
    }
  };

  const combineName = (firstName, lastName) => {
    let name = '';
    if (firstName) {
      name += firstName;
    }
    if (firstName && lastName) {
      name += ` ${lastName}`;
    } else if (lastName) {
      name = lastName;
    } else {
      name = '-';
    }
    return name;
  };
  return !bookingData || bookingDetailLoading ? (
    <Spin style={{ marginTop: '45%', marginLeft: '45%' }} />
  ) : (
    <div className="longtail-booking-details">
      <div className="longtail-booking-details__header-container">
        <div className="longtail-booking-details__crumb">
          <Link to="/booking">{'Booking List'}</Link>
          <span className="longtail-booking-details__slash">/</span>
          <span className="longtail-booking-details__current">
            {t('landlord.header.menu_link.booking.details')}
          </span>
        </div>
        <Row style={{ paddingBottom: '24px' }}>
          <Col span={16}>
            <h3 className="longtail-booking-details__booking-number">
              {`${t('landlord.long_tail.booking_details.title.booking_number')} - ${referenceId}`}
            </h3>
            <div className="longtail-booking-details__student-info">
              <Row className="longtail-booking-details__info-row" gutter={50}>
                <Col span={16} className="longtail-booking-details__info-col">
                  <Tooltip
                    overlayClassName="longtail-booking-details__info-tooltip"
                    placement="topLeft"
                    trigger="hover"
                    overlay={renderTooltipContainer(
                      `Student Name:${combineName(
                        bookingData?.student?.passportFirstName,
                        bookingData?.student?.passportLastName,
                      )}`,
                    )}
                  >
                    <Paragraph ellipsis className="longtail-booking-details__info">
                      {`Student Name:${combineName(
                        bookingData?.student?.passportFirstName,
                        bookingData?.student?.passportLastName,
                      )}`}
                    </Paragraph>
                  </Tooltip>
                  <Tooltip
                    overlayClassName="longtail-booking-details__info-tooltip"
                    placement="topLeft"
                    trigger="hover"
                    overlay={renderTooltipContainer(
                      t('landlord.long_tail.booking_details.label.student_mobile', {
                        value: bookingData?.student?.phoneNumber,
                      }),
                    )}
                  >
                    <Paragraph ellipsis className="longtail-booking-details__info">
                      {t('landlord.long_tail.booking_details.label.student_mobile', {
                        value: bookingData?.student?.phoneNumber,
                      })}
                    </Paragraph>
                  </Tooltip>
                  <Tooltip
                    overlayClassName="longtail-booking-details__info-tooltip"
                    placement="topLeft"
                    trigger="hover"
                    overlay={renderTooltipContainer(
                      t('landlord.long_tail.booking_details.label.student_email', {
                        value: bookingData?.student?.emailAddress,
                      }),
                    )}
                  >
                    <Paragraph ellipsis className="longtail-booking-details__info">
                      {t('landlord.long_tail.booking_details.label.student_email', {
                        value: bookingData?.student?.emailAddress,
                      })}
                    </Paragraph>
                  </Tooltip>
                </Col>
                <Col
                  span={8}
                  className="longtail-booking-details__info-col"
                  style={{ width: 'auto', marginLeft: 0, paddingLeft: 0 }}
                >
                  <Tooltip
                    overlayClassName="longtail-booking-details__info-tooltip"
                    placement="topLeft"
                    trigger="hover"
                    overlay={renderTooltipContainer(
                      t('landlord.long_tail.booking_details.label.room') +
                        (bookingData.unitTypeCategory
                          ? t(
                              `landlord.long_tail.booking.unit_type_category.${bookingData.unitTypeCategory.toLowerCase()}`,
                            )
                          : '') +
                        (bookingData.unitTypeName ? `, ${bookingData.unitTypeName}` : '') +
                        (bookingData.propertyName ? `, ${bookingData.propertyName}` : ''),
                    )}
                  >
                    <Paragraph ellipsis className="longtail-booking-details__info">
                      {t('landlord.long_tail.booking_details.label.room') +
                        (bookingData.unitTypeCategory
                          ? t(
                              `landlord.long_tail.booking.unit_type_category.${bookingData.unitTypeCategory.toLowerCase()}`,
                            )
                          : '') +
                        (bookingData.unitTypeName ? `, ${bookingData.unitTypeName}` : '') +
                        (bookingData.propertyName ? `, ${bookingData.propertyName}` : '')}
                    </Paragraph>
                  </Tooltip>
                  <Tooltip
                    overlayClassName="longtail-booking-details__info-tooltip"
                    placement="topLeft"
                    trigger="hover"
                    overlay={renderTooltipContainer(
                      'Desired ' +
                        t('landlord.long_tail.booking_details.label.move_in_date', {
                          value: bookingData.moveInDate
                            ? moment(bookingData.moveInDate).format('DD/MM/YYYY')
                            : '-',
                        }),
                    )}
                  >
                    <Paragraph ellipsis className="longtail-booking-details__info">
                      {'Desired ' +
                        t('landlord.long_tail.booking_details.label.move_in_date', {
                          value: bookingData.moveInDate
                            ? moment(bookingData.moveInDate).format('DD/MM/YYYY')
                            : '-',
                        })}
                    </Paragraph>
                  </Tooltip>
                  <Tooltip
                    overlayClassName="longtail-booking-details__info-tooltip"
                    placement="topLeft"
                    trigger="hover"
                    overlay={renderTooltipContainer(
                      'Desired ' +
                        t('landlord.long_tail.booking_details.label.move_out_date', {
                          value: bookingData.moveOutDate
                            ? moment(bookingData.moveOutDate).format('DD/MM/YYYY')
                            : '-',
                        }),
                    )}
                  >
                    <Paragraph ellipsis className="longtail-booking-details__info">
                      {'Desired ' +
                        t('landlord.long_tail.booking_details.label.move_out_date', {
                          value: bookingData.moveOutDate
                            ? moment(bookingData.moveOutDate).format('DD/MM/YYYY')
                            : '-',
                        })}
                    </Paragraph>
                  </Tooltip>
                </Col>
              </Row>
            </div>
          </Col>
          <Col span={8}>
            {isLeadGen && (
              <BookingStatus
                id={bookingData.id}
                stage={bookingData.stage}
                canUpdate={bookingData.canUpdateListOrderStage}
                shouldDisplayButton={true}
              />
            )}
          </Col>
        </Row>
      </div>
      <div className="longtail-booking-details__header-nav">
        <ul className="longtail-booking-details__nav-list">
          <For of={Object.keys(headerNavList)} each="item" index="index">
            <li
              key={item}
              className={classNames('longtail-booking-details__nav-item', {
                'longtail-booking-details__nav-item--active': currentTab === index,
              })}
              onClick={() => {
                handleNavClick(item, index);
              }}
              role="presentation"
            >
              <span className="longtail-booking-details__nav-label">
                {t(`landlord.long_tail.booking_details.label.${item.replace(/-/g, '_')}`)}
              </span>
            </li>
          </For>
        </ul>
      </div>

      <div className="longtail-booking-details__block" id="student-info">
        <label className="longtail-booking-details__block-title">
          {t('landlord.long_tail.booking_details.label.student_info')}
        </label>
        <LeadgenStudentInfo t={t} student={bookingData?.studentData} bookingData={bookingData} />
      </div>

      <div className="longtail-booking-details__block" id="product-info">
        <label className="longtail-booking-details__block-title">
          {t('landlord.long_tail.booking_details.label.product_info')}
        </label>
        <ProductInfo bookingData={bookingData} property={bookingData?.property} />
      </div>

      {isLeadGen && (
        <>
          <div className="longtail-booking-details__block" id="commission-info">
            <label className="longtail-booking-details__block-title">
              {t('landlord.long_tail.booking_details.label.commission_info')}
            </label>
            <CommissionInfo commissionTriggerPoint={bookingData?.commissionTriggerPoint} />
          </div>
          <div className="longtail-booking-details__block" id="note-info">
            <label className="longtail-booking-details__block-title">{'Notes'}</label>
            {!bookingData?.orderNotes?.length ? (
              <div style={{ textAlign: 'center', marginTop: '34px' }}>
                <Empty description={'This booking does not have any notes yet'} />
              </div>
            ) : (
              <>
                <div style={{ marginTop: '32px' }}>
                  <Timeline>
                    {bookingData?.orderNotes?.map((item, idx) => (
                      <Timeline.Item
                        key={idx}
                        color="gray"
                        dot={
                          <div
                            style={{
                              width: '8px',
                              height: '8px',
                              backgroundColor: '#BFBFBF',
                              borderRadius: '50%',
                            }}
                          />
                        }
                        style={{
                          fontSize: '14px',
                          lineHeight: '22px',
                          fontWeight: 400,
                          color: 'rgba(0, 0, 0, 0.45)',
                        }}
                      >
                        <div style={{ display: 'flex' }}>
                          <div>
                            <div style={{ color: 'rgba(0, 0, 0, 0.85)' }}>{item.note}</div>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                              }}
                            >
                              <div> {moment(item.updatedAt).format('MMM DD,YYYY')}</div>
                              <Divider type="vertical" />
                              <div>{item.updatedByName} </div>
                            </div>
                          </div>
                        </div>
                      </Timeline.Item>
                    ))}
                  </Timeline>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default BookingDetail;
